import { useState } from "react";
import { Link } from "react-router-dom";
import { Search, Package, ArrowRight } from "lucide-react";
import { API } from "@/lib/api";
import { useSite, fiyatYaz } from "@/lib/siteDil";
import { normTr } from "@/lib/ara";

export const grupGorsel = (g) => {
  const n = normTr(g);
  if (n.includes("agir")) return "/site/agir.jpg";
  if (n.includes("hafif") || n.includes("binek")) return "/site/hafif.jpg";
  if (n.includes("makine")) return "/site/is.jpg";
  return "/site/hortum.jpg";
};

export const Fiyat = ({ u, buyuk }) => {
  const { t, lang } = useSite();
  if (!u.perakende_fiyati) return <span className="text-xs text-slate-500" data-testid={`site-fiyat-yok-${u.kod}`}>{t.fiyatSor}</span>;
  return (
    <span className="flex flex-col" data-testid={`site-fiyat-${u.kod}`}>
      <span className="text-[10px] uppercase tracking-wider text-slate-500">{t.perakende}</span>
      <span className={`s-head font-bold text-slate-900 ${buyuk ? "text-3xl" : "text-lg"}`}>{fiyatYaz(u.perakende_fiyati, u.para_birimi, lang)} <span className="text-xs font-medium text-slate-500">{t.kdv}</span></span>
    </span>
  );
};

export const Gorsel = ({ u, className }) => {
  const [hata, setHata] = useState(false);
  if (!u.gorsel || hata) return <div className={`${className} bg-[var(--s-surface)] flex items-center justify-center`}><Package className="w-10 h-10 text-slate-300" /></div>;
  return <img src={`${API}/urun-gorsel/${u.id}`} alt={u.ad} loading="lazy" onError={() => setHata(true)} className={`${className} object-contain bg-white`} />;
};

export const UrunKarti = ({ u, i = 0 }) => {
  const { t, yol } = useSite();
  return (
    <Link to={yol(`/urun/${encodeURIComponent(u.kod)}`)} data-testid={`site-urun-${u.kod}`} style={{ animationDelay: `${Math.min(i, 12) * 40}ms` }}
      className="s-giris group bg-white border border-slate-200 rounded-md overflow-hidden flex flex-col hover:shadow-lg hover:-translate-y-1 hover:border-slate-300 transition-[transform,box-shadow,border-color] duration-200">
      <Gorsel u={u} className="h-44 w-full p-3" />
      <div className="p-4 flex-1 flex flex-col gap-2 border-t border-slate-100">
        <span className="font-mono text-[11px] text-[var(--s-primary)] font-semibold" dir="ltr">{u.kod}</span>
        <span className="text-sm text-slate-800 line-clamp-3 flex-1">{u.ad}</span>
        <div className="flex items-end justify-between gap-2 pt-2">
          <Fiyat u={u} />
          <span className="inline-flex items-center gap-1 text-xs font-semibold text-[var(--s-accent)] shrink-0">{t.incele}<ArrowRight className="w-3.5 h-3.5 rtl:rotate-180 transition-transform group-hover:translate-x-0.5 rtl:group-hover:-translate-x-0.5" /></span>
        </div>
      </div>
    </Link>
  );
};

export const AramaKutusu = ({ baslangic = "", buyuk, onAra }) => {
  const { t, yol, nav } = useSite();
  const [q, setQ] = useState(baslangic);
  const gonder = (e) => { e.preventDefault(); if (onAra) onAra(q.trim()); else nav(yol(`/urunler${q.trim() ? `?q=${encodeURIComponent(q.trim())}` : ""}`)); };
  return (
    <form onSubmit={gonder} className={`flex bg-white rounded-md border border-slate-200 ${buyuk ? "shadow-2xl p-2" : "shadow-sm p-1"}`} data-testid="site-arama">
      <div className="relative flex-1"><Search className={`absolute start-3 top-1/2 -translate-y-1/2 text-slate-400 ${buyuk ? "w-5 h-5" : "w-4 h-4"}`} />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t.araYer} data-testid="site-arama-input"
          className={`w-full bg-transparent outline-none ps-10 pe-3 text-slate-900 placeholder:text-slate-400 ${buyuk ? "h-14 text-base" : "h-10 text-sm"}`} /></div>
      <button type="submit" data-testid="site-arama-buton" className={`rounded-sm bg-[var(--s-primary)] hover:bg-[var(--s-primary-h)] text-white font-semibold transition-colors ${buyuk ? "px-8 text-base" : "px-5 text-sm"}`}>{t.ara}</button>
    </form>
  );
};
